<template>
  <div>
    <div class="form-group">
      <label>Quais documentos</label>

      <div v-for="option in scopeOptions" :key="option.value" class="form-check mb-2">
        <input class="form-check-input" type="radio" :id="`scope-${option.value}`" :value="option.value"
          :checked="option.value === scope" :disabled="disabled" @change="$emit('update:scope', option.value)">
        <label class="form-check-label" :for="`scope-${option.value}`">
          {{ option.label }}
          <small class="text-muted d-block">{{ option.hint }}</small>
        </label>
      </div>
    </div>

    <div class="form-group">
      <label>Como organizar</label>

      <div v-for="option in folderOptions" :key="option.value" class="form-check mb-2">
        <input class="form-check-input" type="radio" :id="`folder-${option.value}`" :value="option.value"
          :checked="option.value === folderMode" :disabled="disabled"
          @change="$emit('update:folderMode', option.value)">
        <label class="form-check-label" :for="`folder-${option.value}`">
          {{ option.label }}
          <small class="text-muted d-block">{{ option.hint }}</small>
        </label>
      </div>
    </div>

    <div class="count-box p-3">
      <p v-if="!hasTypes" class="text-muted small mb-0">
        Marque ao menos um tipo de documento para ver quantos arquivos cada escolha gera.
      </p>

      <p v-else-if="loading && !count" class="text-muted small mb-0">
        Calculando a contagem...
      </p>

      <template v-else-if="count">
        <div class="row">
          <div v-for="option in scopeOptions" :key="option.value" class="col-6">
            <strong class="count-number">{{ formatNumber(count[option.value].documents) }}</strong>
            <span class="d-block small" :class="{ 'text-muted': option.value !== scope }">
              {{ count[option.value].documents === 1 ? 'arquivo' : 'arquivos' }} em
              {{ option.label.toLowerCase() }}
            </span>
          </div>
        </div>

        <p v-if="notice" class="text-muted small mb-0 mt-2">{{ notice }}</p>

        <p v-if="count[scope].over_limit" class="text-danger small mb-0 mt-2">
          Esta escolha gera mais que o limite de {{ formatNumber(count.limit) }} arquivos por exportação.
          Reduza os tipos, a seleção de multas, ou baixe somente os mais recentes.
        </p>
      </template>

      <p v-else class="text-muted small mb-0">
        Não foi possível calcular a contagem.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentExportChoices',
  props: {
    scope: {
      type: String,
      default: 'latest'
    },
    folderMode: {
      type: String,
      default: 'per_ait'
    },
    count: {
      type: Object,
      default: null
    },
    notice: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasTypes: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    scopeOptions: [
      { value: 'latest', label: 'Somente os mais recentes', hint: 'O documento vigente de cada tipo e fase' },
      { value: 'all', label: 'Todos os documentos', hint: 'O histórico completo de cada tipo' }
    ],
    folderOptions: [
      { value: 'per_ait', label: 'Uma pasta por AIT', hint: 'Uma subpasta para cada multa' },
      { value: 'single', label: 'Pasta única', hint: 'Arquivos nomeados com o AIT e a fase' }
    ]
  }),
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString('pt-BR')
    }
  }
}
</script>

<style scoped>
.count-box {
  background-color: #f7f8fa;
  border: 1px solid #e7eaec;
  border-radius: 4px;
}

.count-number {
  font-size: 1.2rem;
}
</style>
